/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import cloneDeep from 'clone-deep';

const deepEqual = (obj1: object, obj2: object) => JSON.stringify(obj1) === JSON.stringify(obj2);

const deepCopy = cloneDeep;

const safelyParseJson = <T extends {}>(json: string): T => {
    try {
        return JSON.parse(json);
    } catch (err) {
        err && console.error(err);
    }

    return {} as T;
};

export {
    deepEqual,
    deepCopy,
    safelyParseJson,
};
